// extracted by mini-css-extract-plugin
export default {"root":"ModulesConfriguration_root__SW1Wn"};